import { jsxs as o, jsx as l } from "react/jsx-runtime";
const h = (t) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...t,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m21.811 32.103.508 1.894h19.967l-.535-1.998h-19.94v.104ZM21.811 38.678v.029l.529 1.969h19.967l-.535-1.998H21.811ZM21.933 45.356l.535 1.998h19.96v-.026l-.528-1.972H21.933Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m47.982 53.985 3.996-1.071V6.028H32L12.022 21.957v32.014a4 4 0 0 0 4 4H49.05l-1.068-3.987v.001ZM31.995 11.143v10.914H18.306l13.689-10.914Zm-15.978 13.91h18.974V10.024h12.991v43.951H16.017V25.053Z"
        }
      )
    ]
  }
);
export {
  h as FinalStatement
};
